<template>
  <song-queue-table
    :items="songQueueItems"
    :publicqueue="true"
  />
</template>

<script setup>
import SongQueueTable from '@/components/bot/SongQueueTable';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { Overlay } from '@/services/Overlay';
import { WS } from '@/services/WS';

const props = defineProps({
  kickletUser: Object,
});

const songQueueItems = ref([]);

onMounted(async () => {
  Overlay.getPublicSongRequests(props.kickletUser.id)
    .then(response => {
      songQueueItems.value = response.data.requests;
    });

  await WS.init();
  WS.subscribePublicUser(props.kickletUser.id, 'song-requests/update');
  WS.onPublicUser(props.kickletUser.id, 'song-requests/update', handleSongRequestUpdate);
});

onBeforeUnmount(() => {
  WS.unsubscribePublicUser(props.kickletUser.id, 'song-requests/update');
  WS.offPublicUser(props.kickletUser.id, 'song-requests/update', handleSongRequestUpdate);
});

function handleSongRequestUpdate (event) {
  switch (event.action) {
    case 'add':
      songQueueItems.value.push(event.data);
      break;
    case 'delete':
      songQueueItems.value = songQueueItems.value.filter(item => item.id !== event.data.songId);
      break;
    case 'clear':
      songQueueItems.value = [];
      break;
  }
}
</script>

<style scoped>

</style>
